
import React from 'react';

const testimonials = [
  {
    quote: "We switched to aerial application two seasons ago and haven’t looked back. No more ruts in wet fields, no more waiting three days after a rain.",
    name: 'Mark Hendricks',
    detail: '2,400 acres · Corn & Soybeans · Lancaster County, PA',
    sector: 'Row Crops',
    image: 'https://public.readdy.ai/ai/img_res/327cd0cecd61891c312e169a3c8f3f06.jpg',
  },
  {
    quote: "The deer were eating us alive on the north fields. Their mitigation program cut our edge‑row losses by at least half. That alone paid for the service twice over.",
    name: 'Janet & Dale Kowalski',
    detail: '1,100 acres · Corn & Wheat · Frederick County, MD',
    sector: 'Grain Production',
    image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20female%20farmer%20in%20her%20fifties%20wearing%20plaid%20shirt%20outdoors%20natural%20lighting%20warm%20smile%20confident%20expression%20rural%20Wisconsin%20farmer%20authentic%20documentary%20style%20photography&width=120&height=120&seq=farmer-janet-001&orientation=squarish',
  },
  {
    quote: "They showed me drainage issues I’d been guessing about for years. We fixed two problem spots and picked up an easy 8 bushels per acre in those zones.",
    name: 'Ray Caldwell',
    detail: '2,000 acres · Corn · Shenandoah Valley, VA',
    sector: 'Land Management',
    image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20older%20male%20farmer%20in%20his%20late%20fifties%20wearing%20denim%20shirt%20outdoors%20natural%20lighting%20experienced%20wise%20expression%20Indiana%20corn%20farmer%20authentic%20documentary%20style%20photography&width=120&height=120&seq=farmer-ray-001&orientation=squarish',
  },
];

export default function IndustryTestimonials() {
  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block text-emerald-700 font-bold text-xs tracking-widest uppercase mb-4">
            From the Field
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Trusted Across Industries
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto font-light">
            Don't take our word for it. Here’s what the farmers we work with have to say.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white rounded-lg p-7 shadow-sm border border-gray-100 hover:shadow-md transition-shadow"
            >
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, j) => (
                  <div key={j} className="w-4 h-4 flex items-center justify-center">
                    {/* Using a self‑closing icon element to avoid JSX parsing issues */}
                    <i className="ri-star-fill text-sm text-emerald-700" />
                  </div>
                ))}
              </div>

              <span className="inline-block text-[11px] font-bold text-emerald-700 bg-emerald-50 px-2 py-0.5 rounded-full mb-3 tracking-wide uppercase">
                {t.sector}
              </span>

              <p className="text-gray-700 leading-relaxed mb-5 text-sm">
                “{t.quote}”
              </p>

              <div className="flex items-center gap-3">
                <img
                  src={t.image}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                  onError={(e) => {
                    // Fallback to a placeholder image if the remote URL fails
                    e.currentTarget.src =
                      'https://via.placeholder.com/120?text=No+Image';
                  }}
                />
                <div>
                  <p className="font-bold text-gray-900 text-sm">{t.name}</p>
                  <p className="text-xs text-gray-500">{t.detail}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
